import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedCategorySelector($companyId: ID!, $id: ID) {
    categories(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        parent { id fullname }
      }
    }
  }
`

export const Query = gql`
  query CategorySelector(
    $companyId: ID!,
    $filters: CategoryFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    categories(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        parent { id fullname }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
